import { render } from "./Standings.vue?vue&type=template&id=236d86dc&scoped=true"
import script from "./Standings.vue?vue&type=script&lang=js"
export * from "./Standings.vue?vue&type=script&lang=js"

import "./Standings.vue?vue&type=style&index=0&id=236d86dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236d86dc"]])

export default __exports__